import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
export function getDateRangePickerToolbarUtilityClass(slot) {
  return generateUtilityClass('MuiDateRangePickerToolbar', slot);
}
export const dateRangePickerToolbarClasses = generateUtilityClasses('MuiDateRangePickerToolbar', ['root', 'container']);